<template>
    <input type="text" ref="inputField" autocomplete="off" />
</template>

<script>
import { nextTick } from 'vue';

export default {
    props: {
        modelValue: {
            type: [String, Date, null],
            default: null,
            required: true,
            validator(value) {
                return (
                    value === null ||
                    value instanceof Date ||
                    typeof value === 'string' ||
                    value instanceof String ||
                    (typeof moment !== 'undefined' && value instanceof moment)
                );
            }
        },
        default_date: {
            type: [String, Date, null],
            default: null
        },
        format: {
            type: String,
            default: 'HH:mm'
        },
        min_date: {
            type: [String, Date, Boolean, Object],
            default: false
        },
        max_date: {
            type: [String, Date, Boolean],
            default: false
        },
        min_time_restriction: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dp: null
        };
    },
    mounted() {
        nextTick(() => {
            if (!this.$refs.inputField) {
                return;
            }

            jQuery(this.$refs.inputField).datetimepicker(this.getOptions());

            this.dp = jQuery(this.$refs.inputField).data('DateTimePicker');

            if (this.modelValue) {
                this.dp.date(this.modelValue);
            }

            if (this.default_date !== null) {
                jQuery(this.$refs.inputField).on('focus', () => {
                    if (!this.modelValue) {
                        this.$emit('update:modelValue', this.default_date);
                    }
                });
            }

            jQuery(this.$refs.inputField).on('dp.change', (e) => {
                if (e.date) {
                    let value = e.date.format(this.format);

                    if (this.min_time_restriction) {
                        let moment_per_day_time = moment(value, 'HH:mm');

                        if (moment_per_day_time.isValid() && moment_per_day_time.hours() == 0 && moment_per_day_time.minutes() < 5) {
                            value = '00:05';
                            jQuery(this.$refs.inputField).val(value);
                        }
                    }

                    this.$emit('update:modelValue', value);
                }
            });
        });
    },
    watch: {
        modelValue(value) {
            if (this.dp) {
                this.dp.date(value || null);
            }
        }
    },
    methods: {
        getOptions() {
            return {
                format: this.format,
                useCurrent: false,
                minDate: this.min_date,
                maxDate: this.max_date,
                icons: {
                    up: "icofont-simple-up",
                    down: "icofont-simple-down"
                }
            };
        }
    },
    unmounted() {
        if (this.dp) {
            this.dp.destroy();
            this.dp = null;
        }
    }
};
</script>